import { useSearchParams } from 'react-router-dom';

export const useIsWebview = () => {
    const [searchParams] = useSearchParams();
    return searchParams.has('wv') && searchParams.get('wv') === 'true';
};

// for when the environment isn't guaranteed to have a react-router context
export const useIsWebviewHeadless = () => {
    const searchParams = document.location.search;
    return searchParams.includes('wv=true');
};
